'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import { event } from '@/lib/analytics'

interface ConversionTrackingProps {
  pageType?: 'product' | 'category' | 'cart' | 'checkout' | 'thank_you'
  productId?: string
  productName?: string
  productPrice?: number
  categoryName?: string
  orderValue?: number
  orderNumber?: string
}

export function ConversionTracking({
  pageType,
  productId,
  productName,
  productPrice,
  categoryName,
  orderValue,
  orderNumber
}: ConversionTrackingProps) {
  const pathname = usePathname()

  useEffect(() => {
    // Track page-specific events
    if (pageType) {
      switch (pageType) {
        case 'product':
          if (productId && productName && productPrice) {
            event({
              action: 'view_item',
              category: 'ecommerce',
              label: productName,
              value: productPrice
            })
          }
          break
          
        case 'category':
          if (categoryName) {
            event({
              action: 'view_item_list',
              category: 'ecommerce',
              label: categoryName
            })
          }
          break
          
        case 'cart':
          event({
            action: 'view_cart',
            category: 'ecommerce'
          })
          break
          
        case 'checkout':
          event({
            action: 'begin_checkout',
            category: 'ecommerce'
          })
          break
          
        case 'thank_you':
          if (orderNumber && orderValue) {
            event({
              action: 'purchase',
              category: 'ecommerce',
              label: orderNumber,
              value: orderValue
            })
          }
          break
      }
    }

    // Track conversion funnel progression
    const trackFunnelStep = () => {
      if (pathname.includes('/product/')) {
        event({
          action: 'funnel_step',
          category: 'conversion',
          label: 'product_view'
        })
      } else if (pathname.includes('/cart')) {
        event({
          action: 'funnel_step',
          category: 'conversion',
          label: 'cart_view'
        })
      } else if (pathname.includes('/checkout')) {
        event({
          action: 'funnel_step',
          category: 'conversion',
          label: 'checkout_view'
        })
      } else if (pathname.includes('/thank-you')) {
        event({
          action: 'funnel_step',
          category: 'conversion',
          label: 'purchase_complete'
        })
      }
    }

    trackFunnelStep()
  }, [pathname, pageType, productId, productName, productPrice, categoryName, orderValue, orderNumber])

  return null
} 